<div class="month-expansion-panel-root">
  <mat-expansion-panel hideToggle="true" #monthItem [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ date | date:'EEEE, MMM d' }}{{ getOrdinal(date) }}
      </mat-panel-title>
      <mat-panel-description>
        <mat-icon *ngIf="!monthItem.expanded">expand_more</mat-icon>
        <mat-icon *ngIf="monthItem.expanded">expand_less</mat-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <ng-content></ng-content>
  </mat-expansion-panel>
</div>
